import { AdminPage } from "./AdminPage";
import { LoginPage } from "./LoginPage";
import { SignedOutPage } from "./SignedOutPage";

export function App() {
  if (window.location.pathname === "/login") return <LoginPage />;
  if (window.location.pathname === "/signed-out") return <SignedOutPage />;
  if (window.location.pathname.startsWith("/admin")) return <AdminPage />;
  return <LoginPage />;
}
